export class SingleResourceBackupZeroEtlConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "routingPolicy",
            "baseName": "routingPolicy",
            "type": "BackupZeroEtlSingleResourceRoutingPolicy",
            "format": ""
        },
        {
            "name": "partitionConfigs",
            "baseName": "partitionConfigs",
            "type": "{ [key: string]: BackupZeroEtlSingleResourcePartitionConfig; }",
            "format": ""
        },
        {
            "name": "globalPartitionConfigs",
            "baseName": "globalPartitionConfigs",
            "type": "BackupZeroEtlSingleResourcePartitionConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SingleResourceBackupZeroEtlConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
